module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-23.e77edcf1.jpg";